import { render, staticRenderFns } from "./edit-questionOfPaperUs.vue?vue&type=template&id=4f2e45d1&scoped=true&"
import script from "./edit-questionOfPaperUs.vue?vue&type=script&lang=ts&"
export * from "./edit-questionOfPaperUs.vue?vue&type=script&lang=ts&"
import style0 from "./edit-questionOfPaperUs.vue?vue&type=style&index=0&id=4f2e45d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e45d1",
  null
  
)

export default component.exports